import styled from "styled-components";
import { BORDER_RADIUS, COLORS, SIZE, DEVICE_TYPE } from "constants/variables";
import { ReactComponent as PartnersIcon } from "assets/svg/PartnersIcon.svg";

export const PartnersSectionContainer = styled.div`
  width: 100%;
  position: relative;
  @media (max-width: 1120px) {
    padding-block: ${SIZE.max40};
  }
`;

export const PartnersCardComponent = styled.div`
  height: ${SIZE.max550};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    height: ${SIZE.max600};
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    height: ${SIZE.max650};
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PartnersCardTitleWrapper = styled.div`
  position: absolute;
  z-index: 5;
  top: 25%;
  @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
    top: 30%;
  }
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    top: 15%;
  }
  @media (max-width: 1120px) {
    top: 10%;
    left: ${SIZE.max80};
  }
`;

export const PartnersCardIconWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: ${SIZE.max40};

  @media (max-width: 1630px) {
    bottom: ${SIZE.max80};
  }
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    bottom: ${SIZE.max120};
  }

  @media (max-width: 1120px) {
    bottom: ${SIZE.max480};
  }

  @media (max-width: 767px) {
    bottom: ${SIZE.max500};
  }

  @media (max-width: 600px) {
    bottom: ${SIZE.max530};
  }

  @media (max-width: 450px) {
    bottom: ${SIZE.max550};
  }
  @media (max-width: 350px) {
    bottom: ${SIZE.max690};
  }
`;

export const PartnersIconComponent = styled(PartnersIcon)`
  height: ${SIZE.max480};

  @media (max-width: 1120px) {
    width: 100%;
  }
`;

export const PartnersCard = styled.div`
  background-color: ${COLORS.FaluRed};
  width: 100%;
  position: absolute;
  bottom: 0;
  border-radius: ${BORDER_RADIUS.radius24};

  @media (max-width: 1120px) {
    height: 100%;
  }

  @media (max-width: 768px) {
    height: fit-content;
  }
`;
export const PartnersCardContent = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: ${SIZE.max40};
  @media (max-width: 1120px) {
    flex-direction: column;
    padding-block: ${SIZE.max120} 0;
  }
`;
export const PartnersCardTextWrapper = styled.div`
  z-index: 5;
  width: 65%;
  padding-inline: ${SIZE.max40};
  padding-block: ${SIZE.max40};

  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    width: ${SIZE.max650};
  }

  @media (max-width: 1120px) {
    padding-inline: ${SIZE.max24};
    width: 100%;
    padding-block: 0 ${SIZE.max24};
  }
`;

export const PartnersCardButtonWrapper = styled.div`
  height: ${SIZE.max40};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${SIZE.max80};
  margin-left: ${SIZE.max180};
  z-index: 5;
  width: fit-content;

  @media (max-width: 1500px) {
    margin-top: ${SIZE.max104};
  }

  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    margin-top: ${SIZE.max104};
  }
  @media (max-width: 1300px) {
    margin-top: ${SIZE.max120};
  }

  @media (max-width: 1200px) {
    margin-top: ${SIZE.max160};
  }

  @media (max-width: 1120px) {
    width: 185px;
    height: 42px;
    margin-left: ${SIZE.max24};
    margin-top: ${SIZE.max12};
  }

  @media (max-width: 768px) {
    margin-bottom: ${SIZE.max40};
  }
`;
